// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgContacts: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, title, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      {...props}
    >
      <title>{title}</title>
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path d="M20.308 20.539a6 6 0 0 0 3.235-3.243C24 16.194 24 14.796 24 12c0-2.796 0-4.193-.457-5.296a6 6 0 0 0-3.235-3.242c.051.087.1.177.147.268C21 4.8 21 6.2 21 9v6c0 2.8 0 4.2-.545 5.27-.046.091-.096.18-.147.268" />
        <path
          fillRule="evenodd"
          d="M.545 3.73C0 4.8 0 6.2 0 9v6c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C3.8 23 5.2 23 8 23h3c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C19 19.2 19 17.8 19 15V9c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C15.2 1 13.8 1 11 1H8c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 .545 3.73m11.976 6.09c0 1.475-.353 2.33-.909 2.81 1.254.868 2.48 2.324 2.146 3.182-.705 1.813-6.754 1.712-7.67 0-.427-.795.777-2.227 2.038-3.116-.6-.465-.985-1.333-.985-2.876 0-1.509 1.205-2.732 2.69-2.732 1.486 0 2.69 1.223 2.69 2.732"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

const Memo = memo(SvgContacts);
export default Memo;
